import angular from 'angular'

import { EventHostModule } from '../../event-host/event-host.module';
import { SharedModule } from '../../shared/shared.module'

import { EditScheduleEventComponent } from './edit-schedule-event.component';
import { ScheduleEventDetailComponent } from './schedule-event-detail.component';
import { ScheduleEventDetailModalComponent } from './schedule-event-detail-modal.component';
import { ScheduleEventListComponent } from './schedule-event-list.component';
import { ScheduleEventOfficeAssignmentEditorComponent } from './schedule-event-office-assignment-editor.component';

/**
 * A module exposing shared components for events scheduling.
 */
export const EventsSchedulingSharedModule = angular
    .module("apex.mainApp.eventsScheduling.shared", [
        // Use components for displaying event host details.
        EventHostModule,
        SharedModule
    ])
    .component("apexEditScheduleEvent", EditScheduleEventComponent)
    .component("apexScheduleEventDetail", ScheduleEventDetailComponent)
    .component("apexScheduleEventDetailModal", ScheduleEventDetailModalComponent)
    .component("apexScheduleEventList", ScheduleEventListComponent)
    .component("apexScheduleEventOfficeAssignmentEditor", ScheduleEventOfficeAssignmentEditorComponent)
    .name
